import { render, staticRenderFns } from "./RangchaProductList.vue?vue&type=template&id=52d7dc72&scoped=true"
import script from "./RangchaProductList.vue?vue&type=script&lang=js"
export * from "./RangchaProductList.vue?vue&type=script&lang=js"
import style0 from "./RangchaProductList.vue?vue&type=style&index=0&id=52d7dc72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7dc72",
  null
  
)

export default component.exports